// extracted by mini-css-extract-plugin
export var header = "_vk-1";
export var maskBottom = "_vk-6";
export var maskMiddle = "_vk-7";
export var maskTop = "_vk-5";
export var root = "_vk-0";
export var scrollDownButton = "_vk-3";
export var scrollDownButtonHidden = "_vk-4";
export var viewport = "_vk-2";